var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgGraphCoin = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 6C7.28 6 2.25 7.546 2.25 10.5V14.5C2.25 17.454 7.28 19 12.25 19C17.22 19 22.25 17.454 22.25 14.5V10.5C22.25 7.546 17.22 6 12.25 6ZM4.25 14.5V13.303C4.88334 13.6617 5.55399 13.9501 6.25 14.163V16.044C4.938 15.53 4.25 14.918 4.25 14.5ZM16.25 14.648V16.619C15.383 16.798 14.383 16.929 13.25 16.977V14.977C14.2564 14.9369 15.2588 14.827 16.25 14.648ZM11.25 16.978C10.242 16.9394 9.23877 16.8197 8.25 16.62V14.649C9.209 14.823 10.222 14.936 11.25 14.979V16.978ZM18.25 16.044V14.163C18.9462 13.9505 19.6169 13.6621 20.25 13.303V14.5C20.25 14.918 19.563 15.53 18.25 16.044ZM12.25 13C7.073 13 4.25 11.349 4.25 10.5C4.25 9.651 7.073 8 12.25 8C17.427 8 20.25 9.651 20.25 10.5C20.25 11.349 17.427 13 12.25 13Z",
    fill: "black"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGraphCoin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/GraphCoin.59c5f1e3.svg";
export { ForwardRef as ReactComponent };